module.exports = __webpack_public_path__ + "img/serviceplan-logo.cde8d5e9.svg";